export default __webpack_public_path__ + "static/media/gh.87df1b86.svg";